module.exports = __webpack_public_path__ + "assets/trash.0af59175.svg";